import { faArrowsAlt, faEyeDropper, faHome, faListAlt } from "@fortawesome/free-solid-svg-icons";
import type { Menu, SubMenu } from "./types";

export const MENU_TYPES = {
    SUBMENU_SECTION: "section",
    SUBMENU: "submenu",
    LINK: "link",
    COLOR_LINK: "color-link",
    EMPTY_SPACE: "empty-space",
} as const;

export const colors: SubMenu = {
    type: MENU_TYPES.SUBMENU,
    icon: faEyeDropper,
    name: "Färg",
    children: [
        {
            name: "Multifärgad",
            type: MENU_TYPES.COLOR_LINK,
            url: "/multifargade-mattor",
            color: "url('/images/multi-color.png') no-repeat",
        },
        { name: "Vit", type: MENU_TYPES.COLOR_LINK, url: "/vita-mattor", color: "white" },
        { name: "Svart", type: MENU_TYPES.COLOR_LINK, url: "/svarta-mattor", color: "black" },
        { name: "Grå", type: MENU_TYPES.COLOR_LINK, url: "/gra-mattor", color: "gray" },
        { name: "Beige", type: MENU_TYPES.COLOR_LINK, url: "/beiga-mattor", color: "beige" },
        { name: "Brun", type: MENU_TYPES.COLOR_LINK, url: "/bruna-mattor", color: "brown" },
        { name: "Orange", type: MENU_TYPES.COLOR_LINK, url: "/oranga-mattor", color: "orange" },
        { name: "Grön", type: MENU_TYPES.COLOR_LINK, url: "/grona-mattor", color: "green" },
        { name: "Gul", type: MENU_TYPES.COLOR_LINK, url: "/gula-mattor", color: "yellow" },
        { name: "Turkos", type: MENU_TYPES.COLOR_LINK, url: "/turkosa-mattor", color: "#00eaff" },
        { name: "Blå", type: MENU_TYPES.COLOR_LINK, url: "/bla-mattor", color: "blue" },
        { name: "Lila", type: MENU_TYPES.COLOR_LINK, url: "/lila-mattor", color: "purple" },
        { name: "Röd", type: MENU_TYPES.COLOR_LINK, url: "/roda-mattor", color: "red" },
        { name: "Rosa", type: MENU_TYPES.COLOR_LINK, url: "/rosa-mattor", color: "pink" },
    ],
};

export const menuRoomMappings = {
    vardagsrumsmattor: { title: "Vardagsrummet", id: 74 },
    "mattor-kok": { title: "Köket", id: 72 },
    hallmattor: { title: "Hallen", id: 73 },
    "mattor-till-matsal-matplats": { title: "Matplats / Matsal", id: 76 },
    "mattor-till-sovrum": { title: "Sovrum / Säng", id: 77 },
    "mattor-till-entren": { title: "Entrén", id: 78 },
    utomhusmattor: { title: "Utomhus", id: 113 },
    "mattor-till-barnrum": { title: "Barnrummet", id: 75 },
};

export const rooms: SubMenu = {
    type: MENU_TYPES.SUBMENU,
    icon: faHome,
    name: "Rum",
    children: Object.entries(menuRoomMappings).map(([slug, { title }]) => {
        return {
            name: title,
            type: MENU_TYPES.LINK,
            url: `/${slug}`,
        };
    }),
};

export const menu: Menu = [
    [
        {
            type: MENU_TYPES.SUBMENU,
            icon: faListAlt,
            name: "Alla mattor",
            children: [
                { name: "Badrumsmattor", type: MENU_TYPES.LINK, url: "/badrumsmattor" },
                { name: "Balkong- och altan", type: MENU_TYPES.LINK, url: "/balkong-altan-mattor" },
                { name: "Barnmattor", type: MENU_TYPES.LINK, url: "/barnmattor" },
                { name: "Bomullsmattor", type: MENU_TYPES.LINK, url: "/bomullsmattor" },
                { name: "Chenille", type: MENU_TYPES.LINK, url: "/chenille" },

                { name: "Dörrmattor", type: MENU_TYPES.LINK, url: "/dorrmattor" },
                { name: "Dörrmattor - metervara", type: MENU_TYPES.LINK, url: "/mattbestallda-dorrmattor" },
                { name: "Flatvävda / Slätvävda", type: MENU_TYPES.LINK, url: "/flatvavda_mattor" },
                { name: "Företagsmattor", type: MENU_TYPES.LINK, url: "/mattor_foretag_och_offentlig" },

                { name: "Gångmattor", type: MENU_TYPES.LINK, url: "/gangmattor" },
                { name: "Gångmattor på metervara", type: MENU_TYPES.LINK, url: "/gangmattor-pa-metervara" },
                { name: "Gummerade mattor", type: MENU_TYPES.LINK, url: "/gummerade_mattor_hallmattor" },
                { name: "Handknutna mattor", type: MENU_TYPES.LINK, url: "/handknutna_mattor" },
                { name: "Hundvänliga mattor", type: MENU_TYPES.LINK, url: "/matta-nar-man-har-hund" },

                { name: "Husbil och Husvagn", type: MENU_TYPES.LINK, url: "/mattor-husbil-husvagn" },
                { name: "Julmattor", type: MENU_TYPES.LINK, url: "/julmattor" },
                { name: "Jute & Sisalmattor", type: MENU_TYPES.LINK, url: "/jute-sisal-mattor" },
                { name: "Konstsilkesmattor", type: MENU_TYPES.LINK, url: "/silkesmattor" },
                { name: "Måttbeställda mattor", type: MENU_TYPES.LINK, url: "/mattbestallda-mattor" },
                { name: "Orientaliska mattor", type: MENU_TYPES.LINK, url: "/orientaliska-mattor" },

                { name: "Patchwork", type: MENU_TYPES.LINK, url: "/patchwork" },
                { name: "Plastmattor", type: MENU_TYPES.LINK, url: "/plastmattor" },
                { name: "Plast- och garnmattor", type: MENU_TYPES.LINK, url: "/plast_och_garn_mattor" },
                { name: "Ripsmattor", type: MENU_TYPES.LINK, url: "/ripsmattor" },
                { name: "Ryamattor", type: MENU_TYPES.LINK, url: "/ryamattor" },
                { name: "Röllakan", type: MENU_TYPES.LINK, url: "/rollakan_mattor" },
                { name: "Skinn och hudar", type: MENU_TYPES.LINK, url: "/skinn" },
                { name: "Textilplattor", type: MENU_TYPES.LINK, url: "/textilplattor" },
                { name: "Tillbehör", type: MENU_TYPES.LINK, url: "/tillbehor" },
                { name: "Trappmattor", type: MENU_TYPES.LINK, url: "/trappmattor" },
                { name: "Trasmattor", type: MENU_TYPES.LINK, url: "/trasmattor" },
                { name: "Ullmattor", type: MENU_TYPES.LINK, url: "/ullmattor" },
                { name: "Ullmattor - Eget mått", type: MENU_TYPES.LINK, url: "/ullmatta-i-eget-matt" },
                { name: "Wiltonmattor", type: MENU_TYPES.LINK, url: "/wiltonmattor" },
                { type: MENU_TYPES.EMPTY_SPACE },
            ],
        },
        {
            type: MENU_TYPES.SUBMENU,
            icon: faArrowsAlt,
            name: "Storlek",
            children: [
                {
                    type: MENU_TYPES.SUBMENU_SECTION,
                    name: "Vanliga storlekar",
                    subtitle: "(Bredd x längd)",
                    children: [
                        { name: "ca 60 x 90 cm", type: MENU_TYPES.LINK, url: "/mattor-storlek-60-x-90-cm" },
                        { name: "ca 60 x 120 cm", type: MENU_TYPES.LINK, url: "/mattor-storlek-60-x-120-cm" },
                        { name: "ca 80 x 150 cm", type: MENU_TYPES.LINK, url: "/mattor-storlek-80-x-150-cm" },
                        { name: "ca 80 x 200 cm", type: MENU_TYPES.LINK, url: "/mattor-storlek-80-x-200-cm" },
                        { name: "ca 80 x 250 cm", type: MENU_TYPES.LINK, url: "/mattor-storlek-80-x-250-cm" },
                        { name: "ca 80 x 300 cm", type: MENU_TYPES.LINK, url: "/mattor-storlek-80-x-300-cm" },
                        { name: "ca 120 x 180 cm", type: MENU_TYPES.LINK, url: "/mattor-storlek-120-x-180-cm" },
                        { name: "ca 140 x 200 cm", type: MENU_TYPES.LINK, url: "/mattor-storlek-140-x-200-cm" },
                        { name: "ca 160 x 230 cm", type: MENU_TYPES.LINK, url: "/mattor-storlek-160-x-230-cm" },
                        { name: "ca 200 x 300 cm", type: MENU_TYPES.LINK, url: "/mattor-storlek-200-x-300-cm" },
                        { name: "Större mattor", type: MENU_TYPES.LINK, url: "/stora-mattor" },
                    ],
                },
                {
                    type: MENU_TYPES.SUBMENU_SECTION,
                    name: "Runda mattor",
                    subtitle: "(Diameter)",
                    children: [
                        { name: "ca 80 cm rund", type: MENU_TYPES.LINK, url: "/runda-mattor-storlek-80-cm" },
                        { name: "ca 100 cm rund", type: MENU_TYPES.LINK, url: "/runda-mattor-storlek-100-cm" },
                        { name: "ca 120 cm rund", type: MENU_TYPES.LINK, url: "/runda-mattor-storlek-120-cm" },
                        { name: "ca 160 cm rund", type: MENU_TYPES.LINK, url: "/runda-mattor-storlek-160-cm" },
                        { name: "ca 200 cm rund", type: MENU_TYPES.LINK, url: "/runda-mattor-storlek-200-cm" },
                        { name: "Alla runda mattor", type: MENU_TYPES.LINK, url: "/runda-mattor" },
                    ],
                },
                {
                    type: MENU_TYPES.SUBMENU_SECTION,
                    name: "Välj bredd",
                    subtitle: "Färdiga storlekar i viss bredd",
                    children: [
                        { name: "50 cm", type: MENU_TYPES.LINK, url: "/mattor-bredd-50-cm" },
                        { name: "60 cm", type: MENU_TYPES.LINK, url: "/mattor-bredd-60-cm" },
                        { name: "70 cm", type: MENU_TYPES.LINK, url: "/mattor-bredd-70-cm" },
                        { name: "80 cm", type: MENU_TYPES.LINK, url: "/mattor-bredd-80-cm" },
                        { name: "90 cm", type: MENU_TYPES.LINK, url: "/mattor-bredd-90-cm" },
                        { name: "100 cm", type: MENU_TYPES.LINK, url: "/mattor-bredd-100-cm" },
                        { name: "120 cm", type: MENU_TYPES.LINK, url: "/mattor-bredd-120-cm" },
                        { name: "140 cm", type: MENU_TYPES.LINK, url: "/mattor-bredd-140-cm" },
                        { name: "160 cm", type: MENU_TYPES.LINK, url: "/mattor-bredd-160-cm" },
                        { name: "200 cm", type: MENU_TYPES.LINK, url: "/mattor-bredd-200-cm" },
                        { name: "Bredare än 200 cm", type: MENU_TYPES.LINK, url: "/mattor-bredd-storre-an-200-cm" },
                    ],
                },
                {
                    type: MENU_TYPES.SUBMENU_SECTION,
                    name: "Metervara",
                    subtitle: "Måttbeställ i egen längd",
                    children: [
                        { name: "50 cm bredd", type: MENU_TYPES.LINK, url: "/mattor-metervara-bredd-50-cm" },
                        { name: "67 cm bredd", type: MENU_TYPES.LINK, url: "/mattor-metervara-bredd-67-cm" },
                        { name: "80 cm bredd", type: MENU_TYPES.LINK, url: "/mattor-metervara-bredd-80-cm" },
                        { name: "100 cm bredd", type: MENU_TYPES.LINK, url: "/mattor-metervara-bredd-100-cm" },
                        { name: "200 cm bredd", type: MENU_TYPES.LINK, url: "/mattor-metervara-bredd-200-cm" },
                    ],
                },
            ],
        },
        colors,
        rooms,
    ],
    [
        {
            name: "Måttbeställda mattor",
            type: MENU_TYPES.LINK,
            url: "/mattbestallda-mattor",
            attributes: { "data-sveltekit-reload": "" },
        },
        { name: "Nyheter", type: MENU_TYPES.LINK, url: "/mattor_nyheter", attributes: { "data-sveltekit-reload": "" } },
        { name: "Inspiration", type: MENU_TYPES.LINK, url: "/mattor-inspiration" },
        { name: "Fynd", type: MENU_TYPES.LINK, url: "/mattor-rea" },
        { name: "Kampanjer", type: MENU_TYPES.LINK, url: "/billiga_mattor_till_kampanjpris" },
    ],
];

export const adminMenu: Menu = [
    [
        {
            type: MENU_TYPES.SUBMENU,
            name: "Dashboards",
            children: [
                { name: "Daglig Ops", type: MENU_TYPES.LINK, url: "/admin/dashboards/operations" },
                { name: "Kunder & Beteende", type: MENU_TYPES.LINK, url: "/admin/dashboards/customers" },
                { name: "Webshop & Annonsering", type: MENU_TYPES.LINK, url: "/admin/dashboards/store" },
                { name: "Finans", type: MENU_TYPES.LINK, url: "/admin/dashboards/finance" },
            ],
        },
        {
            type: MENU_TYPES.SUBMENU,
            name: "Försäljning",
            children: [{ name: "Reor / Kampanjer", type: MENU_TYPES.LINK, url: "/admin/sales" }],
        },
        {
            type: MENU_TYPES.SUBMENU,
            name: "Orderhantering",
            children: [{ name: "Ohanterade ordrar", type: MENU_TYPES.LINK, url: "/admin/orders" }],
        },
        {
            type: MENU_TYPES.SUBMENU,
            name: "Klarna",
            children: [
                { name: "Klarna-kontroll", type: MENU_TYPES.LINK, url: "/admin/check-klarna-captures" },
                { name: "Klarna-order", type: MENU_TYPES.LINK, url: "/admin/klarna-order-info" },
            ],
        },
    ],
];
